// Wraps the sidebar. Handles collapsed state and slide

import * as angular from 'angular';
import { TransitionService, Transition } from '@uirouter/angularjs';
import { IMediaQuery } from '../constants';

function uiSidebar($rootScope: ng.IRootScopeService & any, $window: ng.IWindowService, $timeout: ng.ITimeoutService, $transitions: TransitionService, MEDIA_QUERY: IMediaQuery): ng.IDirective {
    return {
        restrict: 'A',
        link: link
    };

    function link(scope: ng.IScope, element: JQLite) {
        var $win = $($window);

        element.on('click', 'a', function (event: JQueryEventObject) {
            var element = $(this);
            element.parent().siblings('.active').toggleClass('active');
            if (element.next().is('ul')) {
                element.parent().toggleClass('active');
                if (!element.hasClass('openLink')) {
                    event.preventDefault();
                }
            }
        });

        // on mobiles, sidebar starts off-screen
        if (onMobile()) {
            $timeout(() => {
                $rootScope.app.sidebar.isOffscreen = true;
            });
        }
        // hide sidebar on route change
        $transitions.onStart({}, (transition: Transition) => {
            if (onMobile()) {
                $rootScope.app.sidebar.isOffscreen = true;
            }
        });

        function onMobile() {
            return $win.width() < MEDIA_QUERY.tablet + 1; /*Ipad width 768px*/
        }
    }
}

angular
    .module('app.common')
    .directive('uiSidebar', uiSidebar);

uiSidebar.$inject = ['$rootScope', '$window', '$timeout', '$transitions', 'MEDIA_QUERY'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/ui-sidebar.directive.ts